var convert = require('./convert');

module.exports = convert('isEqual', require('../isEqual'));